export function items(state, items) {
  state.items = items;
}
export function item(state, item) {
  state.item = item;
}
export function pagination(state, pagination) {
  state.pagination = pagination;
}